export const MOBILE_MIN_WIDTH = 320;
export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1025;
